"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get EmployeeSummaryEmbeddingDocument () {
        return EmployeeSummaryEmbeddingDocument;
    },
    get EmployeeSummaryEmbeddingSourceKindSchema () {
        return EmployeeSummaryEmbeddingSourceKindSchema;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const EmployeeSummaryEmbeddingSourceKindSchema = _zod.z.enum([
    "review_answer",
    "feedback"
]);
const EmployeeSummaryEmbeddingDocument = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    company_id: _zod.z.instanceof(_bson.ObjectId),
    employee_id: _zod.z.instanceof(_bson.ObjectId),
    source_kind: EmployeeSummaryEmbeddingSourceKindSchema,
    source_id: _zod.z.instanceof(_bson.ObjectId),
    content_hash: _zod.z.string(),
    embedding: _zod.z.array(_zod.z.number()),
    embedding_model: _zod.z.string(),
    source_date: _zod.z.date(),
    indexed_at: _zod.z.date()
});
